import { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch } from 'react-router-dom';

// Queries
import getCategorias from '../Queries/getCategorias.js';

// Components
import Menu from '../Menu';
import ProductsGrid from '../ProductsGrid';
import ToastProductAdded from '../ToastProductAdded';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Drawer from '@mui/material/Drawer';
import ProductDetail from '../ProductDetail';

// Styles
import styles from './index.module.sass';

export default function Catalog({
  webservice,
  screenSize,
  getCookie,
  history,
  match,
  setOrderData,
  setSessionMessage,
  device,
}) {
  const [catSelected, setCatselected] = useState('');
  const [awaitForPath, setAwaitForPath] = useState(true);
  const [tabMenuOpen, setTabMenuOpen] = useState(false);
  const { t } = useTranslation('catalog');
  const [addedArray, setAddedArray] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [menuCategories, setMenuCategories] = useState([]);
  const [showAddById, setShowAddById] = useState(false);

  function handleCatSelected(id) {
    setCatselected(id);
    // setTabMenuOpen(false);
  }

  const getCategories = useCallback(async () => {
    setLoading(true);
    const response = await getCategorias({
      accion: 'ALMAOK',
      usuarioOK: getCookie('usuarioOk'),
      folioPedido: getCookie('folioPedido'),
      almacenSeleccionado: getCookie('warehouse'),
      origen: 'CARRITONUE',
      idioma: window?.localStorage?.getItem('i18nextLng')?.includes('es') ? 0 : 1,
    });

    const { tipoMensaje = 'error', categorias = [], mensaje } = response?.getCategoriasResult || {};

    setSessionMessage(mensaje);

    if (tipoMensaje === 'error') return;

    setMenuCategories(categorias);
    setLoading(false);

    if (categorias.length > 0) {
      const { subcateg = [] } = categorias[0];
      if (subcateg.length > 0) {
        const { numero = '' } = subcateg[0];
        setCatselected(numero);
      }
    }
  }, [getCookie, setSessionMessage]);

  useEffect(() => {
    getCategories();
  }, [getCategories]);

  return (
    <div className={`${styles.catalog} ${styles[screenSize]}`}>
      {screenSize !== 'desktop' && (
        <Drawer anchor='left' open={tabMenuOpen} onClose={() => setTabMenuOpen(false)}>
          <div className={styles.drawerMenu}>
            <Menu
              webservice={webservice}
              screenSize={screenSize}
              setCatselected={handleCatSelected}
              catSelected={catSelected}
              getCookie={getCookie}
              history={history}
              match={match}
              loading={loading}
              menuCategories={menuCategories}
            />
          </div>
        </Drawer>
      )}
      <div className={styles.addedAlert}>
        <ToastProductAdded addedArray={addedArray} setAddedArray={setAddedArray} />
      </div>
      <div className={styles.dashboard}>
        {screenSize === 'desktop' && (
          <div className={`${styles.menu}`}>
            <div className={styles.menuHeader}>
              <i className={`material-icons ${styles.menuIcon}`}>list</i>
              <div className={styles.title}>{t('categoriesTitle')}</div>
            </div>
            <div className={styles.menuContainer}>
              <Menu
                webservice={webservice}
                screenSize={screenSize}
                setCatselected={handleCatSelected}
                catSelected={catSelected}
                getCookie={getCookie}
                history={history}
                match={match}
                loading={loading}
                menuCategories={menuCategories}
              />
            </div>
          </div>
        )}
        <div className={styles.productGrid}>
          <Switch>
            <Route
              path={`${match.path}/productdetail/:productcode`}
              render={(props) => {
                return (
                  <ProductDetail
                    screenSize={screenSize}
                    webservice={webservice}
                    catSelected={catSelected}
                    orderDetail={/*orderData?.detallePedido || */ []}
                    getCookie={getCookie}
                    history={history}
                    addedArray={addedArray}
                    setAddedArray={setAddedArray}
                    setOrderData={setOrderData}
                    setSessionMessage={setSessionMessage}
                    showAddById={showAddById}
                    setShowAddById={setShowAddById}
                    device={device}
                  />
                );
              }}
            />
            <Route
              path={`${match.path}/:cat?/:subcat?`}
              render={(props) => {
                return (
                  <ProductsGrid
                    screenSize={screenSize}
                    webservice={webservice}
                    catSelected={catSelected}
                    orderDetail={/*orderData?.detallePedido || */ []}
                    getCookie={getCookie}
                    history={history}
                    addedArray={addedArray}
                    setAddedArray={setAddedArray}
                    setOrderData={setOrderData}
                    setSessionMessage={setSessionMessage}
                    showAddById={showAddById}
                    setShowAddById={setShowAddById}
                    device={device}
                    awaitForPath={awaitForPath}
                    setCatselected={handleCatSelected}
                    menuCategories={menuCategories}
                    setAwaitForPath={setAwaitForPath}
                  />
                );
              }}
            />
          </Switch>
        </div>
      </div>
      {screenSize !== 'desktop' && (
        <div className={styles.mobileTabs}>
          <BottomNavigation
            showLabels
            value={tabValue}
            onChange={(event, newValue) => {
              setTabValue(newValue);
            }}>
            <BottomNavigationAction
              label={<label className={styles.tabLabel}>Categorías</label>}
              icon={<span className={`material-icons-outlined ${styles.tabIcon}`}>menu</span>}
              onClick={() => setTabMenuOpen(true)}
            />
            <BottomNavigationAction
              label={<label className={styles.tabLabel}>Agregar por ID</label>}
              icon={
                <span className={`material-icons-outlined ${styles.tabIcon}`}>
                  add_shopping_cart
                </span>
              }
              onClick={() => setShowAddById(true)}
            />
            <BottomNavigationAction
              label={<label className={styles.tabLabel}>Ver pedido</label>}
              icon={
                <span className={`material-icons-outlined ${styles.tabIcon}`}>
                  shopping_cart_checkout
                </span>
              }
              onClick={() => history.push(`${match.path}/shoppingcart`)}
            />
          </BottomNavigation>
        </div>
      )}
    </div>
  );
}
